"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _styles = require("@material-ui/core/styles");
var _box = _interopRequireDefault(require("../box"));
var _styles2 = require("../utilities/styles");
const _excluded = ["children", "classes"];
const useClasses = (0, _styles.makeStyles)(theme => ({
  root: {
    height: theme.navigation.height,
    [theme.breakpoints.only('md')]: {
      height: theme.navigation.tablet.height
    },
    [theme.breakpoints.up('md')]: {
      height: theme.navigation.desktop.height
    },
    zIndex: theme.zIndex.appBar + 1
  }
}), {
  classNamePrefix: 'TCUINavigationBar'
});
const NavigationBar = _ref => {
  let {
      children,
      classes
    } = _ref,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const _classes = useClasses();
  return /*#__PURE__*/_react.default.createElement(_Toolbar.default, (0, _extends2.default)({
    component: _box.default,
    disableGutters: true,
    gutters: "navigation"
  }, rest, {
    classes: (0, _styles2.mergeClasses)(_classes, classes)
  }), children);
};
NavigationBar.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.object
};
NavigationBar.defaultProps = {
  children: null,
  classes: {}
};
var _default = exports.default = NavigationBar;